import {
  GOOGLE_PERFORMANCE_URL,
  NICOTINE_QUITLINE_URL,
  RESOURCE_COORDINATOR_URL,
} from './urlsToHandleWithInternalNavigation'

export const WELLNESS_TOOLKIT_BASE_ROUTE = '/secure/wellness/toolkit'
export const NEURODIVERSITY_BASE_ROUTE = '/center-of-excellence/neurodiversity'
export const NEURODIVERSITY_SECURE_BASE_ROUTE = `/secure${NEURODIVERSITY_BASE_ROUTE}`
export const HEALTH_CHALLENGES_BASE_ROUTE = '/health-challenges'
export const HEALTH_CHALLENGES_SECURE_BASE_ROUTE = `/secure${HEALTH_CHALLENGES_BASE_ROUTE}`
export const WOMENS_HEALTH_BASE_ROUTE = `/womens-health`
export const WOMENS_HEALTH_SECURE_BASE_ROUTE = `/secure${WOMENS_HEALTH_BASE_ROUTE}`
export const PEDIATRICS_BASE_ROUTE = '/center-of-excellence/pediatrics'
export const PEDIATRICS_SECURE_BASE_ROUTE = `/secure${PEDIATRICS_BASE_ROUTE}`
export const MANAGER_HUB_BASE_ROUTE = '/manager'
export const MANAGER_HUB_SECURE_BASE_ROUTE = `/secure${MANAGER_HUB_BASE_ROUTE}`

export const PAGE_ROUTES = {
  ANONYMOUS: {
    ROOT: '/anonymous',
    HOME: '/anonymous/home',
    ACCOUNT: '/anonymous/account',
    CARE: '/anonymous/care',
    DISCOVER: '/anonymous/discover',
    // Anonymous users have one Library surface for both Work Hub and Essentials content.
    LIBRARY: '/anonymous/work-hub',
    SETTINGS: '/anonymous/settings',
    DISPLAY_LANGUAGE: '/anonymous/settings/language',
    LOCATION_TIMEZONE: '/anonymous/settings/location',
    CHAT: '/anonymous/chat',
    FAQ: '/anonymous/faq',
    PREMIUM_FEATURE: '/anonymous/premium-feature',
  },
  SECURE_INDEX: '/secure/index',
  HOMEBASE: '/secure/index/search-care',
  SEARCH_CARE: { BENEFITS: '/secure/index/search-care/benefits' },
  WELLBEING_HOME: '/secure/home',
  WELLBEING_CARE: '/secure/care',
  WELLBEING_DISCOVER: '/secure/discover',
  REGISTRATION_ONBOARDING: '/secure/index/account-info/background-info',
  FAVORITED_PROVIDERS: '/secure/index/favorited-providers',
  SEARCH_CARE_REDIRECT: '/secure/index/search-care-redirect',
  ESTABLISH_CONNECTION: '/establish-connection',
  EMAILS_REDIRECT: '/secure/index/emails-redirect',
  ABOUT: 'about',
  ABOUT_CHILD: 'about-child',
  ABOUT_OTHER_ADULT: 'about-other-adult',
  ASSIGNMENTS_NEW: '/secure/assignments', // TODO: will need to figure out what to do for this since this is used for mapping but web has refs to /secure/index/assignments
  MATCHES: 'matches',
  COACHES: 'coaches',
  CLINICAL_DATA_SHARING: '/secure/index/clinical-data-sharing',
  COACHING: {
    COACHES: 'coaching/coaches',
    COACH: 'coaching/coach',
    DEFAULT: 'coaching',
    LOCATION_MATCHER: 'coaching/location',
  },
  SSO_REGISTRATION: 'ssoregistration',
  SSO_REGISTRATION_APPLE: 'ssoregistration/apple',
  SSO_REGISTRATION_GOOGLE: 'ssoregistration/google',
  CONTACT_CARE_TEAM: 'contact-care-team',
  CONTACT_CARE_TEAM_CONFIRMATION: 'contact-care-team/confirmation',
  CARE_TEAM_PHONE_NUMBERS: '/care-team-phone-numbers',
  WORKLIFE_SERVICES: '/worklife',
  WORKLIFE_SERVICES_CONTACT_CARE_INTERNATIONAL: '/worklife-care-team-numbers',
  WORKLIFE_SERVICES_SECURE: '/secure/index/worklife',
  CONTACT_CARE_ADVOCATE_FORM: '/secure/onboard/care-advocate-consultation',
  CONTACT_CARE_ADVOCATE_CONFIRMATION: '/secure/onboard/care-advocate-consultation/confirmation',
  ZERO_SEARCH_RESULTS_REDIRECT: 'zero-search-results-redirect',
  ZERO_SEARCH_RESULTS_RECOMMENDED_TREATMENT_OPTION: 'zero-search-results-recommended-treatment-option',
  MATCH_LOCATION: 'match-location',
  T1_MULTI_PROVIDERS: 't1-multi-providers',
  LATEST_PROVIDER_MATCHES: 'latest-provider-matches',
  UNSUPPORTED_OPTION: 'unsupported',
  VIDEO_THERAPY: 'video-therapy',
  PROVIDER: 'provider',
  PROVIDER_PROFILE: function (id: string) {
    return `/secure/index/provider/${id}`
  },
  PROFILE: {
    DEFAULT: '/secure/profile',
    ELIGIBILITY: '/secure/profile/eligibility',
    SETTINGS: '/secure/profile/settings',
    SESSION_HISTORY: '/secure/profile/session-history',
    HEALTH_PLAN_AND_PAYMENTS: '/secure/profile/health-plan-and-payments',
    PRIVACY_AND_LEGAL: '/secure/profile/privacy-and-legal',
    CHANGE_EMAIL: '/secure/profile/settings/email/change',
    RESET_PASSWORD: '/secure/profile/forgot-password',
    ENROLL_MFA: '/secure/profile/settings/enrollMFA',
    VERIFY_MFA: '/secure/profile/settings/verifyMFA',
    MFA_ENABLED: '/secure/profile/settings/MFAEnabled',
    UPDATE_LOCATION: '/secure/profile/settings/update-location',
    UPDATE_PHONE_NUMBER: '/secure/profile/settings/update-phone-number',
    UPDATE_LANGUAGE: '/secure/profile/settings/language/change',
    UPDATE_NOTIFICATION_SETTINGS: '/secure/profile/settings/update-notification-settings',
    UPDATE_LYRA_UPDATES_SETTINGS: '/secure/profile/settings/update-notification-settings/lyra-updates',
    UPDATE_PERSONAL_INFORMATION: '/secure/profile/update-personal-information',
    UPDATE_CHILD_INFORMATION: '/secure/profile/update-child-information',
    UPDATE_PERSONAL_INFORMATION_QUESTIONNAIRE: '/secure/profile/update-info-questionnaire',
    UPDATE_THEME: '/secure/profile/settings/theme/change',
    UPDATE_CUSTOM_NOTIFICATIONS: '/secure/profile/settings/update-custom-notifications',
    COVERAGE_CHECK: '/secure/coverage-check/profile',
    ADD_FAMILY_MEMBER: '/secure/profile/add-dependent-information',
    DEPENDENT_CONFIRMATION: '/secure/profile/dependent-confirmation',
    SELF_MANAGED_CONFIRMATION: '/secure/profile/self-managed-dependent-confirmation',
    TRANSFER_ACCOUNT: {
      FIND_EMPLOYER: '/secure/profile/eligibility/transfer-account/find-employer',
    },
  },
  CONNECTED_SERVICE_ATTESTATION: '/secure/index/connected-service-attestation',
  COACHING_SESSION_MODALITY_SELECTION: 'session-modality',
  APPOINTMENT_SELECTION: function (id: string) {
    return `provider/${id}/schedule`
  },
  APPOINTMENT_LOGISTICS: function (id: string) {
    return `provider/${id}/appointment`
  },
  APPOINTMENT_REQUEST: function (id: string) {
    return `provider/${id}/request`
  },
  LOCATION_NOT_SUPPORTED: function (id: string) {
    return `provider/${id}/location-not-supported`
  },
  MORE_OPTIONS: 'more-options',
  HOME: '/secure/index',
  ONE_LYRA_ASSIGNMENTS: '/secure/assignments',
  SESSIONS: '/secure/sessions',
  SESSION_SELECTION: 'sessions/reschedule',
  SESSION_DETAILS: 'sessions/details',
  MODALITY_QUESTIONNAIRE: {
    INTRO: 'modality-questionnaire',
    SURVEY: 'modality-questionnaire/survey',
    RESULTS: 'modality-questionnaire/results',
  },
  ORIENTATION_ABOUT_US: (id: string) => `orientation/${id}/about-us`,
  ORIENTATION_ABOUT_YOU: (id: string) => `orientation/${id}/about-you`,
  MEDS_OPTIONS_EXPLAINED: {
    ONBOARD: '/secure/onboard/meds-options-explained',
    DIRECT_BOOKING: 'secure/index/meds-options-explained',
  },
  HPI_COVERAGE_CHECK: {
    ONBOARD: {
      DEFAULT: '/secure/coverage-check/onboard',
      HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/plan-info',
      APPOINTMENT_HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/appointment-plan-info',
      APPOINTMENT_PAYMENT_INFO_FORM: '/secure/coverage-check/onboard/appointment-payment-info',
      TREATMENT_HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/treatment-plan-info',
      FOR_CHILD_HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/for-child-plan-info',
    },
    OPTION: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/option/plan-info',
    },
    PROFILE: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/profile/plan-info',
      PAYMENT_INFO_FORM: '/secure/coverage-check/profile/payment-info',
      INFRACTION_PAYMENT_INFO_FORM: '/secure/coverage-check/profile/infraction-payment-info',
    },
    EMAIL: {
      DEFAULT: '/secure/coverage-check/email',
      HEALTH_PLAN_FORM: '/secure/coverage-check/email/plan-info',
      APPOINTMENT_PAYMENT_INFO_FORM: '/secure/coverage-check/email/appointment-payment-info',
      APPOINTMENT_HPI_OVERVIEW: '/secure/coverage-check/email/appointment-hpi-overview',
    },
    PROVIDER: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/provider/plan-info',
      PAYMENT_INFO_FORM: '/secure/coverage-check/provider/payment-info',
    },
    REMINDER: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/reminder/plan-info',
      INFRACTION_PAYMENT_INFO_FORM: '/secure/coverage-check/reminder/infraction-payment-info',
    },
    HEALTH_PLAN_AND_PAYMENT_INFO_OVERVIEW: 'health-plan-and-payment-information-overview',
    HEALTH_PLAN_FORM: 'plan-info',
    PAYMENT_INFO_FORM: 'payment-info',
    INFRACTION_PAYMENT_INFO_FORM: 'infraction-payment-info',
    HEALTH_PLAN_PENDING: 'pending',
    HEALTH_PLAN_INELIGIBLE: 'ineligible',
    HEALTH_PLAN_INELIGIBLE_DIRECT_PATH: 'ineligible-direct-path',
    VIEW_OTHER_OPTIONS: 'view-other-options',
    HIGH_ALERT_RESOURCES: 'resources',
    APPOINTMENT_HEALTH_PLAN_FORM: 'appointment-plan-info',
    APPOINTMENT_PAYMENT_INFO_FORM: 'appointment-payment-info',
    TREATMENT_HEALTH_PLAN_FORM: 'treatment-plan-info',
    FOR_CHILD_HEALTH_PLAN_FORM: 'for-child-plan-info',
    APPOINTMENT_HPI_OVERVIEW: 'appointment-hpi-overview',
  },
  CARE_NAVIGATOR_OPTIONS: {
    DEFAULT: 'care-navigator-options',
    SECURE_INDEX: '/secure/index/care-navigator-options',
    ONBOARD: '/secure/onboard/care-navigator-options',
  },
  ONBOARD_BASE: '/secure/onboard',
  ONBOARD: {
    SUMMARY: '/secure/onboard/summary',
    ABOUT: '/secure/onboard/about',
    ABOUT_CHILD: '/secure/onboard/about-child',
    ABOUT_CHILD_INFO: '/secure/onboard/about-child/info',
    MATCH_LOCATION: '/secure/onboard/match-location',
    CHILD_CARE_NAVIGATOR_OPTIONS: '/secure/onboard/child-care-navigator-options',
  },
  PATHWAYS: {
    FORKED_TRIAGE: '/pathways/care-options',
    SELF_CARE: '/pathways/self-care-options',
    ESSENTIALS_HOMEPAGE_WIDGET: '/pathways/essentials-homepage-widget',
  },
  WELLNESS_CHECK_IN: {
    DEFAULT: '/wellness-check-in',
    PREVIEW: '/wellness-check-in/preview',
    RESULTS: '/secure/wellness-check-in/results',
  },
  WORK_HUB: '/secure/index/work-hub',
  ESSENTIALS: '/secure/index/essentials',
  ESSENTIALS_ARTICLES: '/essentials/articles',
  ESSENTIALS_EVENTS: '/essentials/events',
  LOGIN: '/login',
  APPOINTMENT_CONFIRMATION_PARENT_LED_TEEN: 'appointment/confirmation/parent-led-teen',
  COMPLEX_CARE: '/secure/index/complex-care',
  MANAGER_COACHING: '/secure/index/manager-coaching',
  FAMILY_CARE_OPTIONS: '/secure/index/family-care-options',
  ELECTION: '/election',
  FAMILY_HUB: `${WELLNESS_TOOLKIT_BASE_ROUTE}/family`,
  UNSUBSCRIBE: '/unsubscribe',
  CARE_INITIAL: '/secure/index/care/initial',
  SOCIAL_CARE: RESOURCE_COORDINATOR_URL,
  NICOTINE_QUITLINE: NICOTINE_QUITLINE_URL,
  PROGRESS: '/progress',
  REGISTER: '/register/connect',
  REGISTER_SSO_INTERSTITIAL: '/register/sso-interstitial',
  REGISTER_VERIFY: '/register/verify',
  REGISTER_ACCOUNT_SETUP: '/register/account-setup/basic-info',
  MICROSITE: '/',
  GOOGLE_PERFORMANCE: GOOGLE_PERFORMANCE_URL,
  VERIFY_ATTESTATION: '/verify-attestation',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  COMING_SOON_MICROSITE: '/comingSoon',
  CENTER_OF_EXCELLENCE: {
    NEURODIVERSITY: {
      LANDING_PAGE: NEURODIVERSITY_BASE_ROUTE,
      CONTACT_CARE_NAVIGATOR: `${NEURODIVERSITY_SECURE_BASE_ROUTE}/contact-care-navigator`,
      ONBOARD_CONTACT_CARE_NAVIGATOR: '/secure/onboard/neurodiversity/contact-care-navigator',
      CARE_OPTIONS: `${NEURODIVERSITY_SECURE_BASE_ROUTE}/care-options`,
    },
    HEALTH_CHALLENGES: {
      LANDING_PAGE: HEALTH_CHALLENGES_BASE_ROUTE,
      CARE_OPTIONS: `${HEALTH_CHALLENGES_SECURE_BASE_ROUTE}/care-options`,
    },
    WOMENS_HEALTH: {
      LANDING_PAGE: WOMENS_HEALTH_BASE_ROUTE,
      CARE_OPTIONS: `${WOMENS_HEALTH_SECURE_BASE_ROUTE}/care-options`,
    },
    PEDIATRICS: {
      LANDING_PAGE: PEDIATRICS_BASE_ROUTE,
      ONBOARD_CONTACT_CARE_NAVIGATOR: '/secure/onboard/pediatrics/contact-care-navigator',
      ONBOARD_CARE_INTAKE: '/secure/onboard/pediatrics/care-intake',
    },
    MANAGER_HUB: {
      LANDING_PAGE: MANAGER_HUB_BASE_ROUTE,
    },
  },
  PARENTAL_LEAVE_COACHING: '/secure/index/parental-leave-coaching',
  TOOLKIT_DIRECTORY: '/secure/toolkits',
  HEALTH_CHALLENGES_TOOLKIT: HEALTH_CHALLENGES_BASE_ROUTE,
  SMART_SEARCH: '/smart-search',
  FAQ: '/faq',
  POST_MIGRATION_CONSENT: '/secure/index/post-migration-consent',
  NP_TESTING_BASE: '/secure/np-testing',
  NP_TESTING_BOOKING_FOR: '/secure/np-testing/booking-for',
  NP_TESTING_OVERVIEW: '/secure/np-testing/overview',
  NP_TESTING_PROVIDERS: '/secure/np-testing/providers',
  NP_TESTING_CALENDAR: '/secure/np-testing/calendar',
}

export const LATEST_PROVIDER_MATCHES_PATHS = {
  COACHING: `${PAGE_ROUTES.ONBOARD_BASE}/${PAGE_ROUTES.COACHES}/${PAGE_ROUTES.LATEST_PROVIDER_MATCHES}`,
  THERAPY: `${PAGE_ROUTES.ONBOARD_BASE}/${PAGE_ROUTES.T1_MULTI_PROVIDERS}/${PAGE_ROUTES.LATEST_PROVIDER_MATCHES}`,
} as const

export enum APP_SCREEN {
  PROFILE_SESSION_HISTORY = 'ProfileSessionHistory',
  PROFILE_ELIGIBILITY = 'ProfileEligibility',
  PROFILE_PRIVACY_LEGAL = 'ProfilePrivacyLegal',
  PROFILE_HOMEPAGE = 'ProfileHomepage',
  PROFILE_SETTINGS = 'ProfileSettings',
  PROFILE_UPDATE_NOTIFICATION_SETTINGS = 'ProfileUpdateNotificationSettings',
  PROFILE_UPDATE_LYRA_UPDATES = 'ProfileUpdateLyraUpdates',
  CLINICAL_DATA_SHARING = 'ClinicalDataSharing',
  CLINICAL_DATA_SHARING_CREATE_CODE = 'ClinicalDataSharingCreateCode',
  CLINICAL_DATA_SHARING_CONFIRM = 'ClinicalDataSharingConfirm',
  CLINICAL_DATA_SHARING_REQUEST_RECORD = 'ClinicalDataSharingRequestRecord',
  CLINICAL_DATA_SHARING_SUMMARY_LETTER = 'ClinicalDataSharingSummaryLetter',
  PROFILE_CHANGE_EMAIL = 'ProfileChangeEmail',
  PROFILE_UPDATE_CUSTOM_NOTIFICATIONS = 'ProfileUpdateCustomNotifications',
  PROFILE_UPDATE_PHONE_NUMBER = 'ProfileUpdatePhoneNumber',
  PROFILE_UPDATE_LOCATION = 'ProfileUpdateLocation',
  PROFILE_UPDATE_PERSONAL_INFORMATION = 'ProfileUpdatePersonalInformation',
  HEALTH_PLAN_AND_PAYMENT_INFORMATION = 'HealthPlanAndPaymentInformation',
  HEALTH_PLAN_INFORMATION = 'HealthPlanInformation',
  HEALTH_PLAN_ELIGIBILITY = 'HealthPlanEligibility',
  HEALTH_PLAN_ELIGIBILITY_PENDING = 'HealthPlanEligibilityPending',
  PROFILE_PAYMENT = 'ProfilePayment',
  PROFILE_INFRACTION_PAYMENT = 'ProfileInfractionPayment',
  PROFILE_FORGOT_PASSWORD = 'ProfileForgotPassword',
  PROFILE_DISPLAY_LANGUAGE = 'ProfileDisplayLanguage',
  PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER = 'ProfileTransferAccountFindEmployer',
  TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION = 'TransferAccountChooseMultiInstanceSubpopulation',
  TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION = 'TransferAccountChooseOneMicrositeSubpopulation',
  TRANSFER_ACCOUNT_CONFIRMATION = 'TransferAccountConfirmation',
  PROFILE_MFA = 'ProfileMFA',
  PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL = 'ProfileUpdateBasicInfoVerifyEmail',
  PROFILE_UPDATE_INFO_QUESTIONNAIRE = 'ProfileUpdateInfoQuestionnaire',
  WORK_LIFE_SERVICES = 'WorkLifeServices',
  TRANSFER_ACCOUNT = 'TransferAccount',
  ASSIGNMENTS = 'Activities',
  ACTIVITY = 'Activity',
  ACTIVITY_OVERVIEW = 'ActivityOverview',
  LESSON = 'Lesson',
  PROFILE_ADD_FAMILY_MEMBER = 'ProfileAddFamilyMember',
  PROFILE_DEPENDENT_CONFIRMATION = 'ProfileDependentConfirmation',
  PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION = 'ProfileSelfManagedDependentConfirmation',
  PROFILE_UPDATE_CHILD_INFORMATION = 'ProfileUpdateChildInformation',
  PROVIDER_PROFILE = 'ProviderProfile',
  CARE_INITIAL = 'CareInitial',
  ZOOM_VIDEO_SESSION = 'ZoomVideoSession',
  ESSENTIALS = 'Essentials',
  SMART_SEARCH = 'SmartSearch',
  HOMEBASE = 'Homebase',
  WELLNESS_TOOLKIT = 'WellnessToolkit',
  TOOLKIT_DIRECTORY = 'ToolkitDirectory',
  FORKED_TRIAGE = 'ForkedTriage',
  DBT_SELF_PAY_OPT_IN = 'DbtSelfPayOptIn',
  DBT_NEXT_UP = 'DbtNextUp',
  COVERAGE_CHECK_EMAIL = 'CoverageCheckEmail',
  DBT_HEALTH_PLAN = 'DbtHealthPlan',
  POST_MIGRATION_CONSENT = 'PostMigrationConsent',
  NP_TESTING_BOOKING_FOR_SELECTION = 'NPTestingBookingForSelection',
  NP_TESTING_OVERVIEW = 'NPTestingOverview',
}

export enum APP_ROUTE {
  PROFILE_SESSION_HISTORY = '/secure/profile/session-history',
  PROFILE_ELIGIBILITY = '/secure/profile/eligibility',
  PROFILE_PRIVACY_LEGAL = '/secure/profile/privacy-and-legal',
  PROFILE_HOMEPAGE = '/secure/profile',
  PROFILE_SETTINGS = '/secure/profile/settings',
  PROFILE_UPDATE_NOTIFICATION_SETTINGS = '/secure/profile/settings/update-notification-settings',
  PROFILE_UPDATE_LYRA_UPDATES = '/secure/profile/settings/update-notification-settings/lyra-updates',
  CLINICAL_DATA_SHARING = '/secure/index/clinical-data-sharing',
  CLINICAL_DATA_SHARING_CREATE_CODE = '/secure/index/clinical-data-sharing/create-code',
  CLINICAL_DATA_SHARING_REQUEST_RECORD = '/secure/index/clinical-data-sharing/request-record',
  CLINICAL_DATA_SHARING_SUMMARY_LETTER = '/secure/index/clinical-data-sharing/summary-letter',
  HEALTH_PLAN_AND_PAYMENT_INFORMATION = '/secure/profile/health-plan-and-payments',
  CLINICAL_DATA_SHARING_CONFIRM = '/secure/index/clinical-data-sharing/confirmation',
  PROFILE_CHANGE_EMAIL = '/secure/profile/settings/email/change',
  PROFILE_UPDATE_CUSTOM_NOTIFICATIONS = '/secure/profile/settings/update-custom-notifications',
  PROFILE_UPDATE_PHONE_NUMBER = '/secure/profile/settings/update-phone-number',
  PROFILE_UPDATE_LOCATION = '/secure/profile/settings/update-location',
  PROFILE_UPDATE_PERSONAL_INFORMATION = '/secure/profile/update-personal-information',
  HEALTH_PLAN_INFORMATION = '/secure/coverage-check/profile/plan-info',
  HEALTH_PLAN_ELIGIBILITY = '/secure/coverage-check/profile/ineligible',
  HEALTH_PLAN_ELIGIBILITY_PENDING = '/secure/coverage-check/profile/pending',
  PROFILE_PAYMENT = '/secure/coverage-check/profile/payment-info',
  PROFILE_PAYMENT_UPDATE = '/secure/coverage-check/profile/payment-info-update',
  PROFILE_INFRACTION_PAYMENT = '/secure/coverage-check/profile/infraction-payment-info',
  PROFILE_FORGOT_PASSWORD = '/secure/profile/forgot-password',
  PROFILE_DISPLAY_LANGUAGE = '/secure/profile/settings/language/change',
  PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER = '/secure/profile/eligibility/transfer-account/find-employer',
  TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION = '/secure/profile/eligibility/transfer-account/choose-subpopulation/redirect',
  TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION = '/secure/profile/eligibility/transfer-account/choose-subpopulation',
  TRANSFER_ACCOUNT_CONFIRMATION = '/secure/profile/eligibility/transfer-account/confirmation',
  PROFILE_MFA = '/secure/profile/settings/enrollMFA',
  PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL = '/secure/profile/update-personal-information/verify',
  PROFILE_UPDATE_INFO_QUESTIONNAIRE = '/secure/profile/update-info-questionnaire',
  WORK_LIFE_SERVICES = '/worklife',
  WORK_LIFE_SERVICES_SECURE = '/secure/index/worklife',
  TRANSFER_ACCOUNT = '/secure/profile/eligibility/transfer-account/basic-info',
  ASSIGNMENTS = '/secure/assignments',
  ACTIVITY = '/secure/activity',
  ACTIVITY_OVERVIEW = '/secure/activity-overview',
  LESSON = '/secure/lesson',
  PROFILE_ADD_FAMILY_MEMBER = '/secure/profile/add-dependent-information',
  PROFILE_DEPENDENT_CONFIRMATION = '/secure/profile/dependent-confirmation',
  PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION = '/secure/profile/self-managed-dependent-confirmation',
  PROFILE_UPDATE_CHILD_INFORMATION = '/secure/profile/update-child-information',
  PROVIDER_PROFILE_DIRECT_BOOKING = '/secure/index/provider',
  CARE_INITIAL = '/secure/care/initial',
  ZOOM_VIDEO_SESSION = '/secure/video-session',
  SESSIONS = '/secure/sessions',
  ESSENTIALS = '/secure/index/essentials',
  SMART_SEARCH = '/smart-search',
  /** 1Lyra's Care Navigator phone directory. LyraWeb's equivalent is PAGE_ROUTES.CARE_TEAM_PHONE_NUMBERS. */
  CONTACT_CARE_NAVIGATOR_INTERNATIONAL = '/secure/index/contact-care-navigator-international',
  SECURE_INDEX = '/secure/index',
  CONFIRM_COVERAGE_BASIC_INFO = '/secure/index/confirm-coverage/basic-info',
  HOMEBASE = '/secure/index/search-care',
  // These must match the 1Lyra linking config in Lyraweb-mobile Root.tsx (SECURE stack screens),
  // which is not flag-gated. They are allowlisted via homebaseRoutes/directBookingLinkRoutes so
  // cancel/rebook stays in 1Lyra even when is1LyraEnabledForSessions is off.
  CANCEL_SESSION = '/secure/sessions/cancel',
  REBOOK_AFTER_CANCEL = '/secure/sessions/rebook',
  REBOOK_AFTER_CANCEL_CALENDAR = '/secure/sessions/rebook-calendar',
  REBOOK_AFTER_CANCEL_CONTACT = '/secure/sessions/rebook-contact',
  FAMILY_CARE_OPTIONS = '/secure/index/family-care-options',
  WELLNESS_TOOLKIT = '/secure/wellness/toolkit',
  TRAUMA_CHECKIN = '/secure/wellness/trauma-checkin',
  TOOLKIT_DIRECTORY = '/secure/toolkits',
  FORKED_TRIAGE = '/pathways/care-options',
  DBT_SELF_PAY_OPT_IN = '/secure/dbt/onboard/self-pay-opt-in',
  DBT_NEXT_UP = '/secure/dbt/onboard/next-up',
  COVERAGE_CHECK_EMAIL = '/secure/coverage-check/email',
  DBT_HEALTH_PLAN = '/secure/dbt/onboard/healthplan',
  WELLNESS_CHECK_IN = '/secure/wellness-check-in',
  CMS_MICROSITE_METADATA = '/secure/index/cms-microsite',
  DBT_TEEN_ONBOARDING = '/secure/dbt/onboard/teen',
  DBT_TEEN_SELECT = '/secure/dbt/onboard/teen-select',
  DBT_TEEN_CONTACT_INFO = '/secure/dbt/onboard/teen-contact',
  DBT_TEEN_CONFIRMATION = '/secure/dbt/onboard/teen-confirmation',
  DBT_TEEN_BOOKING_BLOCK = '/secure/dbt/onboard/teen-booking',
  WOMENS_HEALTH_TOOLKIT = '/secure/womens-health/care-options',
  HEALTH_CHALLENGES_TOOLKIT = '/secure/health-challenges/care-options',
  NEURODIVERSITY_CENTER_OF_EXCELLENCE = '/secure/center-of-excellence/neurodiversity',
  FAVORITED_PROVIDERS = '/secure/index/favorited-providers',
  POST_MIGRATION_CONSENT = '/secure/index/post-migration-consent',
}

export const homebaseRoutes: string[] = [
  APP_ROUTE.SECURE_INDEX,
  APP_ROUTE.CONFIRM_COVERAGE_BASIC_INFO,
  APP_ROUTE.HOMEBASE,
  `${APP_ROUTE.HOMEBASE}/*`,
  APP_ROUTE.CANCEL_SESSION,
  APP_ROUTE.REBOOK_AFTER_CANCEL,
  APP_ROUTE.REBOOK_AFTER_CANCEL_CALENDAR,
  APP_ROUTE.REBOOK_AFTER_CANCEL_CONTACT,
  APP_ROUTE.FAMILY_CARE_OPTIONS,
  APP_ROUTE.WELLNESS_TOOLKIT,
  `${APP_ROUTE.WELLNESS_TOOLKIT}/*`,
  APP_ROUTE.TRAUMA_CHECKIN,
  `${APP_ROUTE.TRAUMA_CHECKIN}/*`,
  APP_ROUTE.TOOLKIT_DIRECTORY,
  APP_ROUTE.FORKED_TRIAGE,
  WOMENS_HEALTH_SECURE_BASE_ROUTE,
  APP_ROUTE.WOMENS_HEALTH_TOOLKIT,
  HEALTH_CHALLENGES_SECURE_BASE_ROUTE,
  APP_ROUTE.HEALTH_CHALLENGES_TOOLKIT,
  APP_ROUTE.NEURODIVERSITY_CENTER_OF_EXCELLENCE,
  `${APP_ROUTE.NEURODIVERSITY_CENTER_OF_EXCELLENCE}/*`,
  NEURODIVERSITY_BASE_ROUTE,
  `${NEURODIVERSITY_BASE_ROUTE}/*`,
  APP_ROUTE.FAVORITED_PROVIDERS,
]

const directBookingLinkRoutes: string[] = [
  APP_ROUTE.PROVIDER_PROFILE_DIRECT_BOOKING,
  APP_ROUTE.REBOOK_AFTER_CANCEL_CALENDAR,
]

export const routesEnabledInNativeApp: string[] = [
  APP_ROUTE.CLINICAL_DATA_SHARING,
  APP_ROUTE.CLINICAL_DATA_SHARING_CREATE_CODE,
  APP_ROUTE.CLINICAL_DATA_SHARING_CONFIRM,
  APP_ROUTE.CLINICAL_DATA_SHARING_REQUEST_RECORD,
  APP_ROUTE.CLINICAL_DATA_SHARING_SUMMARY_LETTER,
  APP_ROUTE.WORK_LIFE_SERVICES,
  APP_ROUTE.WORK_LIFE_SERVICES_SECURE,
  APP_ROUTE.TRANSFER_ACCOUNT,
  APP_ROUTE.TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION,
  APP_ROUTE.TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION,
  APP_ROUTE.TRANSFER_ACCOUNT_CONFIRMATION,
  APP_ROUTE.ZOOM_VIDEO_SESSION,
  APP_ROUTE.SMART_SEARCH,
  // Enabled so links to the phone directory (e.g. from smart search FAQ answers) render the
  // in-app screen. LyraWeb has no matching route, so ejecting would land on Homebase.
  APP_ROUTE.CONTACT_CARE_NAVIGATOR_INTERNATIONAL,
  APP_ROUTE.DBT_SELF_PAY_OPT_IN,
  APP_ROUTE.DBT_NEXT_UP,
  // Profile Routes
  APP_ROUTE.PROFILE_HOMEPAGE,
  APP_ROUTE.PROFILE_SETTINGS,
  APP_ROUTE.PROFILE_CHANGE_EMAIL,
  APP_ROUTE.PROFILE_UPDATE_NOTIFICATION_SETTINGS,
  APP_ROUTE.PROFILE_UPDATE_LYRA_UPDATES,
  APP_ROUTE.PROFILE_UPDATE_CUSTOM_NOTIFICATIONS,
  APP_ROUTE.PROFILE_UPDATE_PHONE_NUMBER,
  APP_ROUTE.PROFILE_UPDATE_LOCATION,
  APP_ROUTE.PROFILE_UPDATE_PERSONAL_INFORMATION,
  APP_ROUTE.HEALTH_PLAN_AND_PAYMENT_INFORMATION,
  APP_ROUTE.HEALTH_PLAN_INFORMATION,
  APP_ROUTE.HEALTH_PLAN_ELIGIBILITY,
  APP_ROUTE.HEALTH_PLAN_ELIGIBILITY_PENDING,
  APP_ROUTE.PROFILE_PAYMENT,
  APP_ROUTE.PROFILE_PAYMENT_UPDATE,
  APP_ROUTE.PROFILE_INFRACTION_PAYMENT,
  APP_ROUTE.PROFILE_FORGOT_PASSWORD,
  APP_ROUTE.PROFILE_DISPLAY_LANGUAGE,
  APP_ROUTE.PROFILE_MFA,
  APP_ROUTE.PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL,
  APP_ROUTE.PROFILE_UPDATE_INFO_QUESTIONNAIRE,
  APP_ROUTE.PROFILE_ADD_FAMILY_MEMBER,
  APP_ROUTE.PROFILE_DEPENDENT_CONFIRMATION,
  APP_ROUTE.PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION,
  APP_ROUTE.PROFILE_UPDATE_CHILD_INFORMATION,
  APP_ROUTE.PROFILE_SESSION_HISTORY,
  APP_ROUTE.PROFILE_ELIGIBILITY,
  APP_ROUTE.PROFILE_PRIVACY_LEGAL,
  APP_ROUTE.PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER,
  APP_ROUTE.COVERAGE_CHECK_EMAIL,
  APP_ROUTE.DBT_HEALTH_PLAN,
  APP_ROUTE.CMS_MICROSITE_METADATA,
  APP_ROUTE.DBT_TEEN_ONBOARDING,
  APP_ROUTE.DBT_TEEN_SELECT,
  APP_ROUTE.DBT_TEEN_CONTACT_INFO,
  APP_ROUTE.DBT_TEEN_CONFIRMATION,
  APP_ROUTE.DBT_TEEN_BOOKING_BLOCK,
  MANAGER_HUB_BASE_ROUTE,
  MANAGER_HUB_SECURE_BASE_ROUTE,
]

export const careRoutes: string[] = [
  APP_ROUTE.ASSIGNMENTS,
  `${APP_ROUTE.ASSIGNMENTS}/*`,
  APP_ROUTE.ACTIVITY,
  `${APP_ROUTE.ACTIVITY}/*`,
  APP_ROUTE.ACTIVITY_OVERVIEW,
  `${APP_ROUTE.ACTIVITY_OVERVIEW}/*`,
  APP_ROUTE.LESSON,
  `${APP_ROUTE.LESSON}/*`,
  APP_ROUTE.CARE_INITIAL,
  `${APP_ROUTE.CARE_INITIAL}/*`,
  APP_ROUTE.ESSENTIALS,
  `${APP_ROUTE.ESSENTIALS}/*`,
  '/essentials',
  '/essentials/*',
]

export const sessionsRoutes: string[] = [
  APP_ROUTE.SESSIONS,
  `${APP_ROUTE.SESSIONS}/*`,
  // Also match the internal /secure/index/sessions path used by lyrahealthwebapp's React Router,
  // so usePathChanged can intercept and hand off to Lyraweb-mobile when the flag is on.
  `${PAGE_ROUTES.HOME}/sessions`,
  `${PAGE_ROUTES.HOME}/sessions/*`,
]

export const s4cRoutes: string[] = [
  PAGE_ROUTES.ONBOARD_BASE,
  `${PAGE_ROUTES.ONBOARD_BASE}/*`,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.ONBOARD.DEFAULT,
  `${PAGE_ROUTES.HPI_COVERAGE_CHECK.ONBOARD.DEFAULT}/*`,
  '/secure/coverage-check/option/*',
  '/secure/coverage-check/provider/*',
  PAGE_ROUTES.CARE_NAVIGATOR_OPTIONS.SECURE_INDEX,
  `/${PAGE_ROUTES.MEDS_OPTIONS_EXPLAINED.DIRECT_BOOKING}`,
  `${PAGE_ROUTES.HOME}/international-consent`,
  `${PAGE_ROUTES.HOME}/find-different-care-option`,
  `${PAGE_ROUTES.HOME}/about-child/ineligible`,
  `${PAGE_ROUTES.HOME}/${PAGE_ROUTES.APPOINTMENT_CONFIRMATION_PARENT_LED_TEEN}`,
]

export const getRoutesEnabledInNativeApp = (
  is1LyraEnabledForHomebase?: boolean,
  is1LyraEnabledForDirectBookingLinks?: boolean,
  is1LyraEnabledForSessions?: boolean,
  is1LyraEnabledForS4C?: boolean,
) => {
  return [
    ...routesEnabledInNativeApp,
    ...careRoutes,
    ...(is1LyraEnabledForSessions ? sessionsRoutes : []),
    ...(is1LyraEnabledForS4C ? s4cRoutes : []),
    ...(is1LyraEnabledForHomebase ? homebaseRoutes : []),
    ...(is1LyraEnabledForDirectBookingLinks ? directBookingLinkRoutes : []),
  ]
}

// TEMPORARY FIX (ACCOUNT-3816): Messaging routes don't have corresponding web routes
// (messenger is accessed via MessagesPopover overlay), so they must render
// as mobile screens to avoid redirecting to non-existent web URLs.
const MESSAGING_ROUTES = ['/secure/messages', '/secure/chat', '/secure/VideoSessionChat']

/**
 * Check if a route is a messaging route that should render as a mobile screen
 * even when not in routesEnabledInNativeApp.
 *
 * @param route - The route path to check (e.g., '/secure/messages', '/secure/chat')
 * @returns true if the route is a messaging route
 */
export const isMessagingRoute = (route: string): boolean => {
  return MESSAGING_ROUTES.some((messagingRoute) => {
    const lower = route.toLowerCase()
    const prefix = messagingRoute.toLowerCase()
    return lower === prefix || lower.startsWith(prefix + '/') || lower.startsWith(prefix + '?')
  })
}

export const ONBOARDING_WELLNESS_GOALS_PATH = '/secure/index/wellness-goals'

export const REDIRECT_URL_KEY = 'REDIRECT_URL'
export const UNAUTHENTICATED_REDIRECT_URL = 'unauthenticatedRedirectUrl'
export const REDIRECT_URL_PARAM = 'redirectUrl'
export const FROM_URL_REDIRECT_KEY = 'fromUrlRedirect'

/** Destination for unauthenticated users hitting a secure route */
export enum AUTH_LANDING_VALUE {
  REGISTRATION = 'registration',
  LOGIN = 'login',
}
